import { StyleSheet } from 'aphrodite';
import { brandPrimaryText } from '../../../styles/colors';
import { THEME } from '@Theme';

export const styleSheet = StyleSheet.create({
	archivedBanner: {
		alignItems: 'center',
		backgroundColor: THEME.colors.danger.light,
		display: 'flex',
		justifyContent: 'center',
		// Escape the container's horizontal padding so the banner spans edge-to-edge
		marginLeft: -16,
		marginRight: -16,
		marginBottom: 8,
		padding: `4px 8px`,
		gap: 8,
		':has(*) svg': {
			display: 'block',
		},
	},
	archivedBannerText: {
		color: THEME.colors.danger.main,
		fontSize: 12,
		fontWeight: 600,
	},
	container: {},
	dataOriginLink: {
		textAlign: 'center',
		width: 'auto',
	},
	dataOriginLinkContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		marginBottom: 30,
	},
	editButton: {
		color: brandPrimaryText,
		fontSize: 14,
		position: 'absolute',
		right: 30,
		top: 60,
	},
	master: {
		boxSizing: 'border-box',
		height: '100%',
		padding: '25px 30px 30px 0',
		position: 'relative',
	},
	masterCompact: {
		boxSizing: 'border-box',
		height: '100%',
		overflowX: 'hidden',
		paddingVertical: 30,
		position: 'relative',
	},
	originDataLoadingSpinner: {
		top: 250,
	},
	toggle: {
		':hover': {
			cursor: 'pointer',
		},
		marginLeft: 10,
	},
});
